import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { imageSizes } from '../../tools/constants.js';
import WrapperComponent from './WrapperComponent.js';

var _excluded = ["alt", "children", "classList", "href", "imageProps", "onClick", "onError", "onLoad", "src", "size", "target", "title"];
var propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  /** Allows users to overlay elements.
   * Please note that the overlay wrapper follows a grid-based layout. */
  children: PropTypes.node,
  /** Lets you add your styles to product image */
  classList: PropTypes.string,
  href: PropTypes.string,
  /** Arbitrary attributes to be applied to the `img` element */
  imageProps: PropTypes.object,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  size: PropTypes.oneOf(imageSizes),
  target: PropTypes.string,
  title: PropTypes.string
};
function ProductImage(_ref) {
  var alt = _ref.alt,
    children = _ref.children,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    href = _ref.href,
    imageProps = _ref.imageProps,
    onClick = _ref.onClick,
    onError = _ref.onError,
    onLoad = _ref.onLoad,
    src = _ref.src,
    size = _ref.size,
    target = _ref.target,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(WrapperComponent, _extends({
    classList: classList,
    href: href,
    target: target,
    onClick: onClick,
    size: size || null
  }, props), /*#__PURE__*/React__default.createElement("img", _extends({
    alt: alt,
    onError: onError,
    onLoad: onLoad,
    title: title,
    src: src
  }, imageProps)), children ? /*#__PURE__*/React__default.createElement("div", {
    className: "product-image-overlay-grid",
    "data-testid": "product-image-overlay-grid"
  }, children) : null);
}
ProductImage.propTypes = propTypes;

export { ProductImage as default };
//# sourceMappingURL=ProductImage.js.map
